// src/components/PrivacyPolicy.jsx

import React from "react";

export default function PrivacyPolicy() {
  return (
    <main className="pt-20 px-6 max-w-4xl mx-auto text-gray-800">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>

      <p className="mb-4 text-base leading-relaxed">
        At CovePoint Development Group, we respect your privacy and are committed to protecting the personal information you share with us. This Privacy Policy outlines how we collect, use, and safeguard your data when you visit our website or interact with us.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Information We Collect</h2>
      <ul className="list-disc ml-6 space-y-1">
        <li>Contact information you provide through forms (name, email, phone, etc.)</li>
        <li>Browser and device data (e.g., IP address, browser type)</li>
        <li>Google reCAPTCHA data to prevent spam and abuse</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">How We Use Your Information</h2>
      <ul className="list-disc ml-6 space-y-1">
        <li>To respond to inquiries and provide customer support</li>
        <li>To protect the security and integrity of our services</li>
        <li>To improve our website and user experience</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Cookies and Tracking</h2>
      <p className="mb-4 text-base leading-relaxed">
        We use cookies and similar technologies to analyze site usage and improve functionality. You can manage your cookie preferences in your browser settings.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Third-Party Services</h2>
      <p className="mb-4 text-base leading-relaxed">
        We use services like Google reCAPTCHA and Resend to secure our forms and send emails. These services may collect information in accordance with their own privacy policies.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Your Rights</h2>
      <p className="mb-4 text-base leading-relaxed">
        You have the right to access, update, or delete your personal data. To make a request, please contact us at info@covepoint.com.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Policy Updates</h2>
      <p className="mb-4 text-base leading-relaxed">
        We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Contact Us</h2>
      <p className="text-base leading-relaxed">
        If you have any questions about this Privacy Policy, please contact us at info@covepoint.com.
      </p>
    </main>
  );
}
